import { render } from "./PanelFooter.vue?vue&type=template&id=5e0fa881&scoped=true"
import script from "./PanelFooter.vue?vue&type=script&lang=js"
export * from "./PanelFooter.vue?vue&type=script&lang=js"

import "./PanelFooter.vue?vue&type=style&index=0&id=5e0fa881&scoped=true&lang=css"

import exportComponent from "../../../../irap-client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e0fa881"]])

export default __exports__